(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GcSystemDetailController', GcSystemDetailController);

    GcSystemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GcSystem'];

    function GcSystemDetailController($scope, $rootScope, $stateParams, previousState, entity, GcSystem) {
        var vm = this;

        vm.gcSystem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:gcSystemUpdate', function(event, result) {
            vm.gcSystem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
